import { getStoreBuilder, BareActionContext } from 'vuex-typex'
import { RootState } from "@/types"
import { BankState, BankStore } from "./types"
import firebase, { functions } from 'firebase'
import { RMUser } from "@/auth/api"

// const delay = (duration: number) => new Promise((c, e) => setTimeout(c, duration))

const b = getStoreBuilder<RootState>().module('Bank', { items: [] })
const stateGetter = b.state()



export const bankStore: BankStore = {
  // state
  get state() { return stateGetter() },

  loadPlaidAccessToken: b.dispatch(loadPlaidAccessToken),
  loadPlaidAccountsBalances: b.dispatch(loadPlaidAccountsBalances),
  isPlaidLinkExist: b.dispatch(isPlaidLinkExist),
}


async function loadPlaidAccessToken(
  context: BareActionContext<BankState, RootState>,
  publicToken: string,
) {
  try {
    const getPlaidAccessToken = firebase.functions().httpsCallable('getPlaidAccessToken')
    await getPlaidAccessToken({ public_token: publicToken })
  } catch (error) {
    throw new Error(error);
  }
}

async function loadPlaidAccountsBalances(
  context: BareActionContext<BankState, RootState>,
) {
  try {
    const getPlaidBalance = firebase.functions().httpsCallable('getPlaidBalance')
    const result = await getPlaidBalance()
    const accounts = result.data.accounts
    return accounts
  } catch (error) {
    throw new Error(error);

  }
}

async function isPlaidLinkExist(
  context: BareActionContext<BankState, RootState>,
  user: RMUser) {
  try {
    const bankInfoCollection = await firebase.firestore().collection('bankInfo').doc(user.uid)
    const bankInfo = await bankInfoCollection.get()    
    return bankInfo.exists ? true : false
  } catch (error) {
    throw new Error(error);
  }
}
